import React, { useState } from 'react';
import T from 'prop-types';
import { useSelector } from 'react-redux';

import ConcentrationChart from './ConcentrationChart';
import ChartTypeToggle from '../../../../_shared/components/ChartTypeToggle';
import { SegmentConcentrationDropdown, segmentConcentrationMetrics } from '../../MetricLists';
import ErrorStateWithReload from '../../../../../../components/ErrorStateWithReload';
import { aiDashboardAppsSelector, segmentConcentrationSelector } from '../../../selectors';

const emptyObject = {};
const emptyArray = [];

const SegmentConcentration = ({ isPress }) => {
  const apps = useSelector(aiDashboardAppsSelector);
  const { settings, data } = useSelector(segmentConcentrationSelector);

  const [segment, setSegment] = useState(Object.keys(segmentConcentrationMetrics)[0]);
  const [chartType, setChartType] = useState('column');

  const isPending = apps.settings.pending || settings.pending;

  if (settings.error) return <ErrorStateWithReload className="py-xl" />;

  return (
    <div className="segment-concentration">
      <header className="section-body-header">
        <div className="section-body-header__left">
          <SegmentConcentrationDropdown selected={segment} onChange={setSegment} />
          <p className="section-body-header__description">
            Shows the share of each AI app’s users that fall into high-frequency or medium-frequency
            AI usage segments.
          </p>
        </div>
        <div className="section-body-header__right">
          <ChartTypeToggle active={chartType} disabled={isPending} onChange={setChartType} />
        </div>
      </header>
      <ConcentrationChart
        series={data.time_series?.[segment] || emptyObject}
        apps={apps.data.top_apps || emptyArray}
        chartType={chartType}
        isPending={isPending}
        isPress={isPress}
      />
    </div>
  );
};

SegmentConcentration.propTypes = {
  isPress: T.bool,
};

export default SegmentConcentration;
